import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * CartDrawerComponent met veilige live update
 * - Badge update (desktop + mobiel)
 * - Drawer update via server-rendered HTML
 * - Auto-open functionaliteit
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = async () => {
    try {
      // 1️⃣ Open drawer als auto-open
      if (this.hasAttribute('auto-open')) {
        this.showDialog();
      }

      // 2️⃣ Fetch actuele cart data
      const cartRes = await fetch('/cart.js');
      const cart = await cartRes.json();

      // 3️⃣ Update badge (desktop + mobiel)
      document.querySelectorAll('.cart-count-bubble').forEach(bubble => {
        bubble.textContent = cart.item_count;
        bubble.classList.toggle('hidden', cart.item_count === 0);
      });

      // 4️⃣ Update drawer met server-rendered HTML
      await this.updateDrawerContents();
    } catch (err) {
      console.error('Cart update failed', err);
    }
  };

  async updateDrawerContents() {
    try {
      const drawerItemsContainer = this.querySelector('.cart-drawer__items');
      if (!drawerItemsContainer) return;

      // Fetch de server-rendered drawer snippet
      const res = await fetch('/cart?view=drawer');
      const drawerHTML = await res.text();

      // Inject HTML
      drawerItemsContainer.innerHTML = drawerHTML;
    } catch (err) {
      console.error('Failed to update drawer HTML', err);
    }
  }

  open() {
    this.showDialog();

    // Close drawer bij Shopify Installments CTA
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

// Registreer custom element als deze nog niet bestaat
if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    // Forceer volledige reload zodat cart, drawer en badge exact synchroon zijn
    window.location.reload();
  }
});

